import BookShowCase from "../../components/bookShowCase/bookShowCase";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import { translate } from "../../app/utils";
import JournalsHighlight from "../../components/journalsHighlight/JournalsHighlight";
import ResourceCollection from "../../components/resourceCollection/ResourceCollection";
import OurServices from "../OurServices/OurServices";
import FeaturesSlider from "./FeaturesSlider/FeaturesSlider";
import "./Home.css";

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="home-container">
        <FeaturesSlider />

        <motion.h3
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 0.3, duration: 0.3, ease: "easeInOut" },
          }}
          style={{ marginLeft: "5px", marginBottom: "5px", marginTop: "60px" }}
        >
          {translate("journals")}
        </motion.h3>

        <motion.div
          className="flex-wrap"
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 0.9, duration: 0.5, ease: "easeInOut" },
          }}
        >
          <JournalsHighlight />
        </motion.div>

        <motion.h3
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 0.3, duration: 0.3, ease: "easeInOut" },
          }}
          style={{ marginLeft: "5px", marginBottom: "5px", marginTop: "60px" }}
        >
          {translate("ourServices")}
          <OurServices />
        </motion.h3>

        {/* <motion.h3
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 0.3, duration: 0.3, ease: "easeInOut" },
          }}
          style={{ marginLeft: "5px", marginBottom: "5px", marginTop: "60px" }}
        >
          {translate("audioBooks")}
        </motion.h3>

        <motion.div
          className="flex-wrap"
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: {
              delay: 0.5,
              duration: 0.5,
              staggerChildren: 0.1,
              ease: "easeInOut",
            },
          }}
        >
          <AudioBookCard />
        </motion.div> */}

        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 1.1, duration: 0.3, ease: "easeInOut" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mt: 8,
              mb: 3,
            }}
          >
            <Typography
              variant="h4"
              fontWeight="800"
              sx={{ color: "text.primary", letterSpacing: 1 }}
            >
              {translate("exploreBooks")}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Button 
                variant="outlined" 
                color="primary" 
                endIcon={<ChevronRightIcon />}
                onClick={() => navigate('/books')}
                sx={{ borderRadius: 8, px: 3, textTransform: 'none', fontWeight: 'bold' }}
              >
                See All
              </Button>
            </Box>
          </Box>
        </motion.div>

        <motion.div
          className="flex-wrap"
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: {
              delay: 1.3,
              duration: 0.5,
              staggerChildren: 0.1,
              ease: "easeInOut",
            },
          }}
        >
          <BookShowCase />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 1.5, duration: 0.3, ease: "easeInOut" },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mt: 8, mb: 3 }}>
            <Typography
              variant="h4"
              fontWeight="800"
              sx={{ color: "text.primary", letterSpacing: 1 }}
            >
              {translate("resourceCollection")}
            </Typography>
          </Box>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 1.5, duration: 0.3, ease: "easeInOut" },
          }}
        >
          <ResourceCollection />
        </motion.div>
      </div>
    </>
  );
};

export default Home;
